import { lazy } from 'react'
import { allAccess, testUser, userRole } from '../util/userBasedAuth'
import AssignToBatch from '../pages/resumeLibrary/AssignToBatch'

const ChangePassword = lazy(() => import('../components/ChangePassword'))
const Login = lazy(() => import('../pages/auth/Login'))
const CreateNewQuestion = lazy(
  () => import('../pages/questionnaire/CreateNewQuestion')
)
const EditQuestion = lazy(() => import('../pages/questionnaire/EditQuestion'))
const ViewQuestion = lazy(() => import('../pages/questionnaire/ViewQuestion'))
const ExamCreation = lazy(() => import('../pages/exam/ExamCreation'))
const ExamList = lazy(() => import('../pages/exam/ExamList'))
const Home = lazy(() => import('../pages/Home'))
const MyProfile = lazy(() => import('../pages/myProfile/MyProfile'))
const AddBranch = lazy(() => import('../pages/organisation/branch/AddBranch'))
const EditBranch = lazy(() => import('../pages/organisation/branch/EditBranch'))
const ViewBranchDetails = lazy(
  () => import('../pages/organisation/branch/ViewBranchDetails')
)
const ViewBranchMembers = lazy(
  () => import('../pages/organisation/branch/ViewBranchMembers')
)
const OrganisationProfile = lazy(
  () => import('../pages/organisation/Organisation')
)
const PurchaseHistory = lazy(() => import('../pages/PurchaseHistory'))

const Notification = lazy(() => import('../pages/notifications/Notification'))
const NotificationsList = lazy(
  () => import('../pages/ApprovalRequest/RequestsListing')
)
const ApprovalRequestDetails = lazy(
  () => import('../pages/ApprovalRequest/RequestsDetails')
)
const BatchAddMembers = lazy(() => import('../pages/batch/BatchAddMembers'))
const BatchCreation = lazy(() => import('../pages/batch/BatchCreation'))
const BatchResult = lazy(() => import('../pages/batch/BatchResult'))
const BatchList = lazy(() => import('../pages/batch/BatchList'))
const Marketplace = lazy(() => import('../pages/marketPlace/MarketPlace'))
const Aptitudetest = lazy(() => import('../pages/marketPlace/AptitudeTest'))
const Checkout = lazy(() => import('../pages/marketPlace/CheckOut'))
const Questionnaire = lazy(() => import('../pages/marketPlace/questionnaire'))
const CreateNewExamDemo = lazy(() => import('../pages/exam/CreateNewExamDemo'))
const ViewPsychometricExamCandidates = lazy(
  () => import('../pages/exam/ViewPsychometricCandidates')
)
const PsychometricExamFeedback = lazy(
  () => import('../pages/exam/PsychometricExamFeedback')
)
const PsychometricExamResult = lazy(
  () => import('../pages/exam/PsychometricExamResult')
)
const StudentList = lazy(() => import('../pages/exam/Student/StudentList'))
const ExamInstructions = lazy(
  () => import('../pages/exam/AttendExam/ExamInstructions')
)
const AttendExam = lazy(() => import('../pages/exam/AttendExam/AttendExam'))
const ThankYou = lazy(() => import('../pages/exam/AttendExam/ThankYou'))
const ViewExamDetails = lazy(() => import('../pages/exam/ViewExamDetails'))
const ViewExamQuestions = lazy(() => import('../pages/exam/ViewExamQuestions'))
const EditExam = lazy(() => import('../pages/exam/EditExam'))
const ReScheduleExam = lazy(() => import('../pages/exam/ReScheduleExam'))
const BulkUpload = lazy(() => import('../pages/questionnaire/BulkUpload'))
const UploadHistory = lazy(() => import('../pages/questionnaire/UploadHistory'))
const Report = lazy(() => import('../pages/Report/Report'))
const ViewAnswers = lazy(() =>
  import('../pages/Report/ViewAnswers').then(({ ViewAnswers }) => ({
    default: ViewAnswers,
  }))
)
const ExternalCandidateRegistration = lazy(
  () =>
    import(
      '../pages/externalCandidateRegistration/externalCandidateRegistration'
    )
)
const StudentHome = lazy(
  () => import('../components/roleBasedDashboard/StudentHome')
)

const ForgotPassword = lazy(() => import('../pages/auth/ForgotPassword'))
const ResetPassword = lazy(() => import('../pages/auth/ResetPassword'))
const CorporateAdminHome = lazy(
  () => import('../components/roleBasedDashboard/CorporateAdminHome')
)
const SMEDashboardHome = lazy(
  () => import('../components/roleBasedDashboard/SMEDashboardHome')
)
const HrHeadHome = lazy(
  () => import('../components/roleBasedDashboard/HrHeadHome')
)
const BranchAdminHome = lazy(
  () => import('../components/roleBasedDashboard/BranchAdminHome')
)
const Reviews = lazy(() => import('../pages/marketPlace/Reviews'))
const PageNotFound = lazy(() => import('../components/PageNotFound'))
const ManagerHome = lazy(
  () => import('../components/roleBasedDashboard/ManagerHome')
)
const AddEmployee = lazy(
  () => import('../pages/organisation/employee-management/AddEmployee')
)
const UploadQuestionnaire = lazy(
  () => import('../pages/questionnaire/UploadQuestionnaire')
)
const AddEmployeeBulkUploadHistory = lazy(
  () =>
    import(
      '../pages/organisation/employee-management/AddEmployeeBulkUplodHistory'
    )
)
const RequestedExam = lazy(() => import('../pages/sme/RequestedExam'))
const SmeCompletedExams = lazy(
  () => import('../pages/hrHead/SmeCompletedExams')
)
const CandidateRegistration = lazy(
  () => import('../pages/externalCandidateRegistration/CandidateRegistration')
)
const RecruitmentAgencies = lazy(
  () => import('../pages/recruitmentAgencies/RecruitmentAgencies')
)
const RecruitmentAgenciesView = lazy(
  () => import('../pages/recruitmentAgencies/RecruitmentAgenciesView')
)
const RecruitmentAgenciesMyClientView = lazy(
  () => import('../pages/recruitmentAgencies/myClientView/MyClientView')
)

const QuestionPaperDetails = lazy(
  () => import('../pages/marketPlace/QuestionPaperDetails')
)
const CreateHiringBatch = lazy(() => import('../pages/batch/CreateHiringBatch'))
const CreateAssessmentBatch = lazy(
  () => import('../pages/batch/CreateAssessmentBatch')
)
const JobRoleList = lazy(() => import('../pages/jobRole/JobRoleList'))
const JobRole = lazy(() => import('../pages/jobRole/JobRoleLists'))

const CreateJobRole = lazy(() => import('../pages/jobRole/CreateJobRole'))
const CreateJobRoles = lazy(() => import('../pages/jobRole/CreateJobRoles'))

const JobRoleDetails = lazy(() => import('../pages/jobRole/JobRoleDetails'))
const ExamDetails = lazy(() => import('../pages/exam/ExamDetailsView'))
const BatchwiseExamDetails = lazy(
  () => import('../pages/exam/Details/BatchwiseExamDetails')
)
const AssignExam = lazy(() => import('../pages/exam/AssignExam'))
const Invitations = lazy(() => import('../pages/invitation/Invitations'))
const ResumeLibrary = lazy(() => import('../pages/resumeLibrary/ResumeLibrary'))

export const publicRoutes = [
  {
    path: '/auth/login',
    element: Login,
    sideBar: false,
    navBar: false,
  },
  {
    path: '/auth/forgot-password',
    element: ForgotPassword,
    sideBar: false,
    navBar: false,
  },
  {
    path: '/auth/reset-password',
    element: ResetPassword,
    sideBar: false,
    navBar: false,
  },
  {
    path: '/auth/register',
    element: ExternalCandidateRegistration,
    sideBar: false,
    navBar: false,
  },
  {
    path: '/auth/user-register',
    element: CandidateRegistration,
    sideBar: false,
    navBar: false,
  },
]
export const privateRoutes = [
  // Dashboard for different roles
  {
    path: '/home',
    element: Home,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.HR_PERSONNEL],
  },
  {
    path: '/home',
    element: StudentHome,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.EXTERNAL_CANDIDATE, userRole.INTERNAL_CANDIDATE],
  },
  {
    path: '/home',
    element: BranchAdminHome,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.BRANCH_ADMIN],
  },
  {
    path: '/home',
    element: ManagerHome,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.MANAGER],
  },
  {
    path: '/home',
    element: CorporateAdminHome,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN],
  },
  {
    path: '/home',
    element: HrHeadHome,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.HR_HEAD],
  },
  {
    path: '/home',
    element: SMEDashboardHome,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.SUBJECT_MATTER_EXPERT],
  },
  {
    path: '/my-profile',
    element: MyProfile,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.CORPORATE_ADMIN,
      userRole.BRANCH_ADMIN,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/change-password',
    element: ChangePassword,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.CORPORATE_ADMIN,
      userRole.BRANCH_ADMIN,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/purchase-history',
    element: PurchaseHistory,
    sideBar: false,
    navBar: false,
    roles: [testUser],
  },
  {
    path: '/organisation',
    element: OrganisationProfile,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN, userRole.BRANCH_ADMIN],
  },
  {
    path: '/view-branch-details/:branchId',
    element: ViewBranchDetails,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN],
  },
  {
    path: '/add-branch',
    element: AddBranch,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN],
  },
  {
    path: '/view-branch-members/:branchId',
    element: ViewBranchMembers,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN],
  },
  {
    path: '/edit-branch/:branchId',
    element: EditBranch,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN],
  },
  {
    path: '/add-batch-members/:identifier',
    element: BatchAddMembers,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/batch/hiring-batch',
    element: CreateHiringBatch,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/batch/hiring-batch/:batchId',
    element: CreateHiringBatch,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/batch/assessment-batch',
    element: CreateAssessmentBatch,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/batch/assessment-batch/:batchId',
    element: CreateAssessmentBatch,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/job-role-list',
    element: JobRoleList,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/job-role',
    element: JobRole,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/job-role-details/:jobRoleId',
    element: JobRoleDetails,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/edit-job-role/:jobRoleId',
    element: CreateJobRole,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/create-job-role',
    element: CreateJobRole,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/create-new-job-role',
    element: CreateJobRoles,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/edit-job-role-details/:jobRoleId',
    element: CreateJobRoles,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/exam-creation',
    element: ExamCreation,
    sideBar: false,
    navBar: true,
    roles: [testUser],
  },
  {
    path: '/create-new-exam',
    element: CreateNewExamDemo,
    sideBar: false,
    navBar: false,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/exam-details/:examId',
    element: ExamDetails,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
    ],
  },
  {
    path: '/batchwise-exam-details',
    element: BatchwiseExamDetails,
    sideBar: false,
    navBar: true,
    roles: [
      // testUser,
      userRole.HR_PERSONNEL,
      // userRole.MANAGER,
      userRole.HR_HEAD,
      // userRole.SUBJECT_MATTER_EXPERT,
      // userRole.EXTERNAL_CANDIDATE,
      // userRole.INTERNAL_CANDIDATE,
    ],
  },
  {
    path: '/assign-exam/:examId',
    element: AssignExam,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/view-candidates',
    element: ViewPsychometricExamCandidates,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/view-candidates/feedback',
    element: PsychometricExamFeedback,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/view-candidates/view-answers',
    element: PsychometricExamResult,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/exams',
    element: ExamList,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
    props: {
      showCreateButton: true,
    },
  },
  {
    path: '/notification',
    element: Notification,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.HR_HEAD],
  },
  // TODO: Below code will be used in future
  // {
  //   path: '/notifications',
  //   element: NotificationsList,
  //   sideBar: false,
  //   navBar: true,
  //   roles: [testUser],
  // },
  {
    path: '/request-details',
    element: ApprovalRequestDetails,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.HR_HEAD],
  },
  {
    path: '/batch-creation',
    element: BatchCreation,
    sideBar: false,
    navBar: true,
    roles: [testUser],
  },
  {
    path: '/batches',
    element: BatchList,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/batch-result/:identifier',
    element: BatchResult,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/market-place',
    element: Marketplace,
    sideBar: false,
    navBar: true,
    roles: [testUser],
  },
  {
    path: '/aptitude-test',
    element: Aptitudetest,
    sideBar: false,
    navBar: true,
    roles: [testUser],
  },
  {
    path: '/reviews',
    element: Reviews,
    sideBar: false,
    navBar: true,
    roles: [testUser],
  },
  {
    path: '/checkout',
    element: Checkout,
    sideBar: false,
    navBar: true,
    roles: [testUser],
  },
  {
    path: '/questionnaire',
    element: Questionnaire,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/recruitment-agencies',
    element: RecruitmentAgencies,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.CORPORATE_ADMIN,
      userRole.BRANCH_ADMIN,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/recruitment-agencies-view/:Id',
    element: RecruitmentAgenciesView,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.CORPORATE_ADMIN,
      userRole.BRANCH_ADMIN,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/recruitment-agencies-my-client-view/:Id',
    element: RecruitmentAgenciesMyClientView,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.CORPORATE_ADMIN,
      userRole.BRANCH_ADMIN,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/question-paper-details/:questionPaperId',
    element: QuestionPaperDetails,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },

  {
    path: '/create-new-question',
    element: CreateNewQuestion,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/edit-question/:Id',
    element: EditQuestion,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/view-question/:Id',
    element: ViewQuestion,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/student-list/:id',
    element: StudentList,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/exams/view-exam/:examId',
    element: ViewExamDetails,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/questions/bulk-upload',
    element: BulkUpload,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/questions/upload-question-paper',
    element: UploadQuestionnaire,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: 'exams/view-questions/:examId',
    element: ViewExamQuestions,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: 'exams/edit-exam/:examId',
    element: EditExam,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: 'exams/re-schedule/:examId',
    element: ReScheduleExam,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/questions/upload-history',
    element: UploadHistory,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/exam-instructions/:examId',
    element: ExamInstructions,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/thank-you/:examId',
    element: ThankYou,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/attend-exam/:examId',
    element: AttendExam,
    sideBar: false,
    navBar: false,
    roles: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/report/:examId/student/:studentId',
    element: Report,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/view-answers/:examId/student/:studentId',
    element: ViewAnswers,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  {
    path: '/add-individual-employee',
    element: AddEmployee,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN, userRole.BRANCH_ADMIN],
  },
  {
    path: '/employee-bulk-upload-history',
    element: AddEmployeeBulkUploadHistory,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.CORPORATE_ADMIN, userRole.BRANCH_ADMIN],
  },
  {
    path: '/requested-exam',
    element: RequestedExam,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.SUBJECT_MATTER_EXPERT],
  },
  {
    path: '/sme-completed-exam',
    element: SmeCompletedExams,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.HR_HEAD, userRole.HR_PERSONNEL],
  },
  {
    path: '/invitations',
    element: Invitations,
    sideBar: false,
    navBar: true,
    roles: [testUser, userRole.EXTERNAL_CANDIDATE],
  },

  {
    path: '/page-not-found',
    element: PageNotFound,
    sideBar: false,
    navBar: true,
    roles: [...allAccess],
  },
  {
    path: '/resume-library',
    element: ResumeLibrary,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
  {
    path: '/assign-batch',
    element: AssignToBatch,
    sideBar: false,
    navBar: true,
    roles: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },
]
